import React from "react";
import PropTypes from "prop-types";
import { SliceZone } from "@prismicio/react";

import { components } from "../components/slices";
import { Layout } from "../components/Layout";
import AppFacts from "../components/AppFacts";
import { useStoreLinks } from "../utils/storeLinks";
import {
  organisationSchema,
  websiteSchema,
  appSchemas,
} from "../utils/structuredData";

const Homepage = ({ data }) => {
  const homepageSlices = data.prismicHomepage.data.body;

  // Store links for the slices. Untagged visitors are counted as the website
  // homepage; a tagged visit (utm_source, or a legacy fb1 / ios_share link)
  // carries its source into the links, see src/utils/inboundSource.js.
  const sliceContext = useStoreLinks("web-home");

  // The app facts and guide links sit after the reviews and before the
  // closing sign-up block.
  const isClosingSlice = (slice) => slice.slice_type === "lead_generation_block";
  const mainSlices = homepageSlices.filter((slice) => !isClosingSlice(slice));
  const closingSlices = homepageSlices.filter(isClosingSlice);

  return (
    <Layout
      metaTitle={data.prismicHomepage.data.title}
      metaDescription={data.prismicHomepage.data.description}
      structuredData={[organisationSchema(), websiteSchema(), ...appSchemas()]}
    >
      <SliceZone
        slices={mainSlices}
        components={components}
        context={sliceContext}
      />
      <AppFacts />
      <SliceZone
        slices={closingSlices}
        components={components}
        context={sliceContext}
      />
    </Layout>
  );
};

Homepage.propTypes = {
  data: PropTypes.shape({
    prismicHomepage: PropTypes.shape({
      data: PropTypes.shape({
        body: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            primary: PropTypes.object,
            slice_type: PropTypes.string,
          })
        ),
      }),
    }),
  }),
};

export default Homepage;
